import { IconProps } from './IconProps';

export const PlayStoreLogo = (props: IconProps) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.06159 0.232178L8.68095 7.65031H8.68185L11.3824 5.02163L2.65672 0.246412C2.39129 0.0952884 2.09151 0.0106239 1.78424 0C1.52406 0.000180556 1.27079 0.0815535 1.06159 0.232178ZM0.715925 15.4077L0.716248 15.4083L0.713508 15.4101L0.715925 15.4077ZM0.715925 15.4077C0.566566 15.1441 0.492241 14.8464 0.500641 14.5454V1.46424C0.499406 1.26567 0.530235 1.06814 0.592 0.878898L8.1136 8.20453L0.715925 15.4077ZM1.32287 15.9233C1.46891 15.9763 1.62384 16.0023 1.77967 15.9998C2.09003 15.9928 2.39345 15.909 2.66129 15.7561L11.1166 11.1303L8.68095 8.75605L1.32287 15.9233ZM11.8429 10.7309L9.24737 8.20541L12.1096 5.41927L14.6522 6.80969C15.1402 7.02236 15.4668 7.48117 15.5 8.00083C15.467 8.52098 15.14 8.98028 14.6513 9.19284L11.8429 10.7309Z"
        fill={props.fill ?? '#000000'}
      />
    </svg>
  );
};

